import request from '@/utils/request2'

// 列表(主数据列表)
export function loadSurveyQuestionnaireDetailListDataApi(data) {
  return request({
    url: 'tms-web/surveyQuestionnaireDetail/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportSurveyQuestionnaireDetailListDataApi(data) {
  return request({
    url: 'tms-web/surveyQuestionnaireDetail/exportByPage',
    method: 'post',
    data
  })
}

// 查看
export function viewSurveyQuestionnaireDetailApi(data) {
  return request({
    url: 'tms-web/surveyQuestionnaireDetail/view',
    method: 'post',
    data
  })
}

// 问卷用户列表
export function listSurveyQuestionnaireUserDataApi(data) {
  return request({
    url: 'tms-web/surveyQuestionnaireDetail/listUser',
    method: 'post',
    data
  })
}

// 发放成长值
export function grantSurveyQuestionnaireDetailApi(data) {
  return request({
    url: 'tms-web/surveyQuestionnaireDetail/grant',
    method: 'post',
    data
  })
}

// 撤销发放成长值
export function revokeSurveyQuestionnaireDetailApi(data) {
  return request({
    url: 'tms-web/surveyQuestionnaireDetail/revoke',
    method: 'post',
    data
  })
}
